import { ReactNode } from 'react';
import { Paper, Stack, Typography } from '@rossum/ui/material';
import { borderRadius } from '@rossum/ui/theme';

type ContentGroupProps = {
  title?: ReactNode;
  description?: ReactNode;
  children: ReactNode;
  isFullWidthLayout?: boolean;
};

export const ContentGroup = ({
  title,
  description,
  children,
  isFullWidthLayout,
}: ContentGroupProps) => {
  const width = isFullWidthLayout ? '100%' : '50%';

  return (
    <Stack
      component={Paper}
      direction={isFullWidthLayout ? 'column' : 'row'}
      px={4}
      py={3}
      gap={4}
      width={1}
      sx={{
        borderRadius: borderRadius('l'),
      }}
    >
      <Stack
        width={width}
        direction="row"
        alignItems="flex-start"
        justifyContent="space-between"
        spacing={2}
      >
        <Stack spacing={1}>
          {title ? <Typography variant="h5">{title}</Typography> : null}
          {description ? (
            <Typography variant="body2" color="text.secondary" component="span">
              {description}
            </Typography>
          ) : null}
        </Stack>
      </Stack>
      <Stack width={width} spacing={3}>
        {children}
      </Stack>
    </Stack>
  );
};
